import React from 'react';
import {   Table, Icon, List, Popup } from 'semantic-ui-react';
import { Link } from "react-router-dom";


const CursoConstanciaRow=({cursoconstancia, onShowModalBorrar, onShowModalActivar, color,form, permisos})=>{
    return (
    <Table.Row>
                        <Table.Cell>{cursoconstancia.descripcion}</Table.Cell>
                        <Table.Cell textAlign="center">{cursoconstancia.estatus}</Table.Cell>
                        <Table.Cell textAlign="center">
                            <List horizontal>
                                <List.Item>
                                    <Link to={"/cursoconstancia/"+cursoconstancia.id}> 
                                     <Popup
                                        trigger={<Icon  name='edit outline' link   size="large"  color="tela" ></Icon>}
                                        content='Editar'
                                       
                                      />
                                     </Link> 
                                    
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name='trash alternate outline' link 
                                            onClick={()=>onShowModalBorrar(cursoconstancia.id)} 
                                            size="large" color="red"  />
                                        }
                                        content='Borrar'
                                      />
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name={cursoconstancia.idEstatus==1?'x':'check'} link  size="large" 
                                                color={cursoconstancia.idEstatus==1?"orange":"green"}  
                                                onClick={()=>onShowModalActivar(cursoconstancia.id)} 
                                            />
                                        }
                                        content={cursoconstancia.idEstatus==1?'Inactivar':'Activar'}
                                      />  
                                    
                                </List.Item>
                            </List>
                    </Table.Cell>
                      
        </Table.Row>
    
    )
}


export default CursoConstanciaRow;